export default __webpack_public_path__ + "static/media/for-supplier.9b21db5d.mp4";